const initState = {
  currentStep: 0,
  step1: [
    {selected: false, text: 'Web Browsing', filterName: 'webBrowsing'},
    {selected: false, text: 'Google Docs/Office', filterName: 'office'},
    {selected: false, text: 'Watching Movies', filterName: 'movies'},
    {selected: false, text: 'Photo/Video Editing', filterName: 'editing'},
    {selected: false, text: 'Gaming', filterName: 'gaming'}
  ],
  step2: [
    {selected: false, text: '<$500', range: [0, 499.99]},
    {selected: false, text: '$500 - $1000', range: [500, 999.99]},
    {selected: false, text: '$1000 - $1500', range: [1000, 1499.99]},
    {selected: false, text: '$1500+', range: [1500, 1000000]},
    {selected: false, text: 'I don\'t know', range: [0, 1000000]}
  ],
  step3: [
    {selected: false, text: 'I don\'t care.'},
    {selected: false, text: 'Apple'},
    {selected: false, text: 'Dell'},
    {selected: false, text: 'Lenovo'},
    {selected: false, text: 'Asus'},
    {selected: false, text: 'Other (Please specify)', otherValue: '', errorState: false}
  ],
  step4: {
    attributes: [
      {selected: false, text: 'portable'},
      {selected: false, text: 'long battery life'},
      {selected: false, text: 'large screen'},
      {selected: false, text: 'touch screen'},
      {selected: false, text: 'built like a brick'}
    ],
    colors: [
      /* Note: I'm overriding these colors */
      {selected: false, text: 'White'},
      {selected: false, text: 'Gray/Silver'},
      {selected: false, text: 'Black'},
      {selected: false, text: 'Pink'},
    ]
  },
  filterCategories: {
    webBrowsing: [
    ],
    office: [
      {type: 'ramSize', sign: '>', value: 4},
      {type: 'hardDriveType', value: 'SSD'}
    ],
    movies: [
      {type: 'ramSize', sign: '>', value: 4},
      {type: 'screenType', value: 'IPS'}
    ],
    editing: [
      {type: 'screenType', value: 'IPS'},
      {type: 'ramSize', sign: '>', value: 16},
      {type: 'hardDriveType', value: 'SSD'},
      {type: 'hardDriveSpace', sign: '>', value: 512},
      {type: 'cpuCores', sign: '>', value: 4},
      {type: 'gpuType', value: 'Discrete'}
    ],
    gaming: [
      {type: 'screenType', value: 'IPS'},
      {type: 'ramSize', sign: '>', value: 8},
      {type: 'hardDriveType', value: 'SSD'},
      {type: 'hardDriveSpace', sign: '>', value: 256},
      {type: 'cpuCores', sign: '>', value: 4},
      {type: 'gpuType', value: 'Discrete'}
    ],
    budgets: [
    ],
    brands: [],
    color: '',
    others: [
      {type: 'weight', sign: '<', value: 4, from: 'portable'},
      {type: 'batteryLife', sign: '>', value: 4, from: 'long battery life'},
      {type: 'screenSize', sign: '>', value: 15, from: 'large screen'},
      {type: 'touchscreen', value: true, from: 'touch screen'},
      {type: 'sturdy', value: true, from: 'built like a brick'}
    ]
  },
  filtersUnsquished: {
    ramSize: {min: 0, max: 10000000},
    hardDriveType: 'SSD',
    hardDriveSpace: 0,
    screenSize: {min: 0, max: 10000000},
    screenType: '',
    cpuCores: 0,
    gpuType: '',
    weight: {min: 0, max: 10000000},
    touchscreen: false,
    budgets: [],
    brands: []
  },
  filtersSquished: {
    ramSize: {min: 0, max: 10000000},
    hardDriveType: '',
    hardDriveSpace: {min: 0, max: 10000000},
    screenSize: {min: 0, max: 10000000},
    screenType: '',
    cpuCores: {min: 0, max: 10000000},
    gpuType: '',
    weight: {min: 0, max: 10000000},
    touchscreen: false,
    budgets: [],
    brands: [],
    color: ''
  }
};

export const LAPTOP_QUIZ_PAGE_CURRENT_STEP_UPDATE = "LAPTOP_QUIZ_PAGE_CURRENT_STEP_UPDATE";
export const updateLaptopQuizPageCurrentStep = (val) => ({type: LAPTOP_QUIZ_PAGE_CURRENT_STEP_UPDATE, payload: val});

export const incrementLaptopQuizPageCurrentStep = () => {
  return (dispatch, getState) => {
    let currentStep = getState().laptopQuizPage.currentStep;
    currentStep++;
    dispatch(updateLaptopQuizPageCurrentStep(currentStep));
  }
}

export const LAPTOP_QUIZ_PAGE_STEP1_UPDATE = "LAPTOP_QUIZ_PAGE_STEP1_UPDATE";
export const updateLaptopQuizPageStep1 = (val) => ({type: LAPTOP_QUIZ_PAGE_STEP1_UPDATE, payload: val});

export const LAPTOP_QUIZ_PAGE_STEP2_UPDATE = "LAPTOP_QUIZ_PAGE_STEP2_UPDATE";
export const updateLaptopQuizPageStep2 = (val) => ({type: LAPTOP_QUIZ_PAGE_STEP2_UPDATE, payload: val});

export const LAPTOP_QUIZ_PAGE_STEP3_UPDATE = "LAPTOP_QUIZ_PAGE_STEP3_UPDATE";
export const updateLaptopQuizPageStep3 = (val) => ({type: LAPTOP_QUIZ_PAGE_STEP3_UPDATE, payload: val});

export const LAPTOP_QUIZ_PAGE_STEP4_UPDATE = "LAPTOP_QUIZ_PAGE_STEP4_UPDATE";
export const updateLaptopQuizPageStep4 = (val) => ({type: LAPTOP_QUIZ_PAGE_STEP4_UPDATE, payload: val});

export const LAPTOP_QUIZ_PAGE_FILTERS_SQUISHED_UPDATE = "LAPTOP_QUIZ_PAGE_FILTERS_SQUISHED_UPDATE";
export const updateLaptopQuizPageFiltersSquished = (val) => ({type: LAPTOP_QUIZ_PAGE_FILTERS_SQUISHED_UPDATE, payload: val});

export default (state = initState, action) => {
  switch (action.type) {
    case LAPTOP_QUIZ_PAGE_CURRENT_STEP_UPDATE:
      return {...state, currentStep: action.payload};
    case LAPTOP_QUIZ_PAGE_STEP1_UPDATE:
      return {...state, step1: action.payload};
    case LAPTOP_QUIZ_PAGE_STEP2_UPDATE:
      return {...state, step2: action.payload};
    case LAPTOP_QUIZ_PAGE_STEP3_UPDATE:
      return {...state, step3: action.payload};
    case LAPTOP_QUIZ_PAGE_STEP4_UPDATE:
      return {...state, step4: action.payload};
    case LAPTOP_QUIZ_PAGE_FILTERS_SQUISHED_UPDATE:
      return {...state, filtersSquished: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/laptopQuizPageReducer.js